/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminGetAllCampaignsResponseApiModel } from '../../models/admin-get-all-campaigns-response-api-model';

export interface GetAllCampaigns$Params {
}

export function getAllCampaigns(http: HttpClient, rootUrl: string, params?: GetAllCampaigns$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminGetAllCampaignsResponseApiModel>> {
  const rb = new RequestBuilder(rootUrl, getAllCampaigns.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdminGetAllCampaignsResponseApiModel>;
    })
  );
}

getAllCampaigns.PATH = '/admin/campaigns';
